import React from 'react'
import _ from 'lodash'
import { Col, Form, Input, Radio, Row, Spin } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'

const VERSION_REGEX = /^\d+\.\d+\.\d+$/

const ForceUpdateForm = (props) => {
  const { formData, isLoading, onSave, form } = props
  const {
    getFieldDecorator,
    validateFields,
    setFieldsValue,
    resetFields,
    getFieldValue
  } = form

  useDeepEffect(() => {
    resetFields()
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        appVersionAndroid: formData.appVersionAndroid,
        appVersionIOS: formData.appVersionIOS,
        forceUpdateAndroid: formData.forceUpdateAndroid || false,
        forceUpdateIOS: formData.forceUpdateIOS || false,
        storeUrlAndroid: formData.storeUrlAndroid,
        storeUrlIOS: formData.storeUrlIOS,
        userAppVersion: formData.userAppVersion
      })
    }
  }, [formData])

  const versionValidator = (rule, value, callback) => {
    if (value && !VERSION_REGEX.test(value)) {
      callback(new Error('Version ต้องเป็นรูปแบบ x.y.z เช่น 1.0.0'))
    } else {
      callback()
    }
  }

  const isValidUrl = (value) => {
    try {
      const url = new URL(value)
      return url.protocol === 'http:' || url.protocol === 'https:'
    } catch (e) {
      return false
    }
  }

  const storeUrlValidator = (field) => (rule, value, callback) => {
    const forceField =
      field === 'storeUrlAndroid' ? 'forceUpdateAndroid' : 'forceUpdateIOS'
    const isForced = getFieldValue(forceField)
    if (isForced && !value) {
      callback(new Error('กรุณาใส่ Store URL ก่อนเปิด Force Update'))
      return
    }
    if (value && !isValidUrl(value)) {
      callback(new Error('URL ไม่ถูกต้อง'))
      return
    }
    callback()
  }

  const versionRequiredValidator = (field) => (rule, value, callback) => {
    const forceField =
      field === 'appVersionAndroid' ? 'forceUpdateAndroid' : 'forceUpdateIOS'
    const isForced = getFieldValue(forceField)
    if (isForced && !value) {
      callback(new Error('กรุณาใส่ Version ก่อนเปิด Force Update'))
    } else {
      callback()
    }
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        onSave({
          appVersionAndroid: values.appVersionAndroid,
          appVersionIOS: values.appVersionIOS,
          forceUpdateAndroid: values.forceUpdateAndroid,
          forceUpdateIOS: values.forceUpdateIOS,
          storeUrlAndroid: values.storeUrlAndroid,
          storeUrlIOS: values.storeUrlIOS,
          userAppVersion: values.userAppVersion
        })
      }
    })
  }

  return (
    <Spin spinning={isLoading}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item label="App Version Android">
              {getFieldDecorator('appVersionAndroid', {
                rules: [
                  { validator: versionValidator },
                  { validator: versionRequiredValidator('appVersionAndroid') }
                ]
              })(<Input placeholder="เช่น 1.0.0" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Force Update Android">
              {getFieldDecorator('forceUpdateAndroid', {
                initialValue: false
              })(
                <Radio.Group
                  onChange={() =>
                    validateFields(
                      ['storeUrlAndroid', 'appVersionAndroid'],
                      { force: true },
                      () => {}
                    )
                  }>
                  <Radio value={true}>Enabled</Radio>
                  <Radio value={false}>Disabled</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <Form.Item label="App Version iOS">
              {getFieldDecorator('appVersionIOS', {
                rules: [
                  { validator: versionValidator },
                  { validator: versionRequiredValidator('appVersionIOS') }
                ]
              })(<Input placeholder="เช่น 1.0.0" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Force Update iOS">
              {getFieldDecorator('forceUpdateIOS', {
                initialValue: false
              })(
                <Radio.Group
                  onChange={() =>
                    validateFields(
                      ['storeUrlIOS', 'appVersionIOS'],
                      { force: true },
                      () => {}
                    )
                  }>
                  <Radio value={true}>Enabled</Radio>
                  <Radio value={false}>Disabled</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="App User Version">
          {getFieldDecorator('userAppVersion')(<Input />)}
        </Form.Item>
        <Form.Item label="Store URL Android">
          {getFieldDecorator('storeUrlAndroid', {
            rules: [{ validator: storeUrlValidator('storeUrlAndroid') }]
          })(
            <Input placeholder="https://play.google.com/store/apps/details?id=..." />
          )}
        </Form.Item>
        <Form.Item label="Store URL iOS">
          {getFieldDecorator('storeUrlIOS', {
            rules: [{ validator: storeUrlValidator('storeUrlIOS') }]
          })(<Input placeholder="https://apps.apple.com/..." />)}
        </Form.Item>
        <Row type="flex" justify="end">
          <Col>
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              htmlType="submit"
              disabled={_.isEmpty(formData)}>
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Spin>
  )
}

const WrappedForceUpdateForm = Form.create({
  name: 'ForceUpdateForm'
})(ForceUpdateForm)

export default WrappedForceUpdateForm
